import React from "react";
import RawMaterials from "../../components/assets/RawMaterials";

const RawMaterialsManagementPage = () => {
  return (
    <>
      <RawMaterials />
    </>
  );
};

export default RawMaterialsManagementPage;
